/* eslint-disable react/jsx-curly-brace-presence */
import React from 'react';
import { useHistory } from 'react-router-dom';
import { Menu, Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
// import { ReactComponent as LogoutSvg } from '../../assets/icons/logout.svg';
import { ReactComponent as MenuSvg } from '../../assets/icons/menu.svg';
import AuthService from "../../services/AuthService";

const styles = {
  row: {
    height: '100%',
  },
  col: {
    display: 'flex',
  },
  menuItem: {
    fontSize: 14,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'center',
    padding: '7px 13px',
  },
  icon: {
    fontSize: '24px',
    cursor: 'pointer',
  },
  logoutText:{
    margin: '0px 5px'
  },
  menuIcon: {
    display: 'flex',
    cursor: 'pointer'
  }
};


function DropdownMenu() {
  const auth = new AuthService();
  const { t } = useTranslation(['common']);
  const history = useHistory();

  const menu = (
    <Menu>
      <Menu.Item style={styles.menuItem} onClick={() => history.push('/speak-doctor')}>
        <span style={styles.logoutText}>Speak Doctor</span>
      </Menu.Item>
      <Menu.Item style={styles.menuItem} onClick={() => history.push('/medical-history')}>
        <span style={styles.logoutText}>Medical Records</span>
      </Menu.Item>
      <Menu.Item style={styles.menuItem} onClick={() => history.push('/user-account')}>
        <span style={styles.logoutText}>My Account</span>
      </Menu.Item>
      <Menu.Item style={styles.menuItem} onClick={() => auth.logout()}>
        <span style={styles.logoutText}>{t(`common:logout`)}</span>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown style={{cursor: 'pointer'}} overlay={menu} trigger={['click']}>
      <div style={styles.menuIcon}><MenuSvg /></div>
    </Dropdown>
  );
}

export default DropdownMenu;
